const attrs = {
  email: "",
  role: ""
};

const options = {
  pathName: "share",
  parentType: "spaces",
  parentKey: "space_id"
};

export default {
  generic: {
    attrs,
    options
  }
};
